import React, { useMemo, useEffect, memo } from 'react';
import { useParams, Link } from 'react-router-dom';
import { posts } from '../data/posts';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import ReactPlayer from 'react-player';
import styled from 'styled-components';
import { Helmet } from 'react-helmet-async';
import './PostPage.css';

//boton de enclace llamado PyPunch a web punchia.online
const Button = styled(Link)`
  background: linear-gradient(45deg, #e63946 0%, #e63946dd 100%);
  color: white;
  padding: 16px 62px;
  border-radius: 50px;
  text-decoration: none;
  font-size: 1.1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  border: 2px solid transparent;

  
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(230, 57, 70, 0.2);
    background: linear-gradient(45deg, #e63946dd 0%, #e63946 100%);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  @media (max-width: 768px) {
    font-size: 1rem;
    padding: 14px 28px;
  }
  @media (max-width: 480px) {
    font-size: 0.9rem;
    padding: 12px 24px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
  margin-top: 30px;
  
  @media (max-width: 480px) {
    gap: 12px;
  }
`;


// Reutilizamos estilos de Home para la promoción de la app
const AppPromoSection = styled.section`
  background: linear-gradient(145deg, #0f172a 0%, #1e1b4b 100%);
  padding: 80px 20px;
  color: white;
  position: relative;
  overflow: hidden;
  @media (max-width: 768px) {
    padding: 60px 15px;
  }
  &::before {
    content: '';
    position: absolute;
    top: 0;left: 0;right: 0;bottom: 0;
    background: radial-gradient(circle at top right, rgba(30, 64, 175, 0.15), transparent 50%),
                radial-gradient(circle at bottom left, rgba(30, 58, 138, 0.1), transparent 50%);
    pointer-events: none;
  }
`;

const AppPromoContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
  @media (max-width: 968px){
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const AppPromoContent = styled.div`
  z-index: 2;
`;

const AppPromoTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 24px;
  span{color:#e63946;}
  @media (max-width:768px){font-size:2rem;}
  @media (max-width:480px){font-size:1.8rem;}
`;

const AppPromoDescription = styled.p`
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 32px;
  color: #e2e8f0;
  @media (max-width:480px){font-size:1rem;margin-bottom:24px;}
`;

const AppStoreButton = styled.a`
  display:inline-flex;align-items:center;
  background:black;color:white;
  padding:12px 24px;border-radius:12px;
  text-decoration:none;font-weight:600;
  transition:all .3s ease;
  &:hover{transform:translateY(-2px);box-shadow:0 4px 12px rgba(0,0,0,0.2);}
  svg{margin-right:8px;}
  @media(max-width:480px){padding:10px 20px;font-size:.9rem;}
`;

const ScreenshotsContainer = styled.div`
  position:relative;display:grid;
  grid-template-columns:repeat(2,1fr);gap:20px;z-index:2;
  @media(max-width:968px){max-width:500px;margin:0 auto;}
`;

const Screenshot = styled.img`
  width:100%;border-radius:20px;
  box-shadow:0 8px 24px rgba(0,0,0,0.2);
  transition:all .3s ease;
  &:hover{transform:translateY(-10px);box-shadow:0 12px 30px rgba(0,0,0,0.3);}
`;

// Contenedor principal del artículo
const Article = styled.article`
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem;
  background: ${({theme})=>theme.colors.surface};
  color: ${({theme})=>theme.colors.text};
  border-radius: ${({theme})=>theme.radius.md};
  box-shadow: ${({theme})=>theme.shadows.md};
`;

const HeaderImg = styled.img`
  width: 100%;
  border-radius:8px;
  object-fit:cover;
  max-height:500px;
  margin-bottom:1.5rem;
  @media(max-width:768px){max-height:300px;}
`;

const Keywords = styled.div`
  display:flex;flex-wrap:wrap;justify-content:center;gap:.7rem;margin-bottom:1.5rem;
`;

const Chip = styled.span`
  background:${({theme})=>theme.colors.secondaryLight};color:${({theme})=>theme.colors.secondary};
  padding:0.35rem 1rem;
  border-radius:20px;
  font-size:.85rem;
  font-weight:600;
`;

const VideoSection = styled.section`
  margin:3rem 0;
`;

// Contenedor que aplica estilos al markdown interno (evita pasar className a ReactMarkdown)
const MarkdownWrapper = styled.div`
  line-height: 1.8;
  font-size: 1.1rem;
  color: ${({theme})=>theme.colors.text};

  h2 {
    font-family: ${({theme})=>theme.fonts.heading};
    font-size: 1.9rem;
    margin-top: 2.5rem;
    margin-bottom: 1rem;
    color: ${({theme})=>theme.colors.secondary};
    border-bottom: 2px solid ${({theme})=>theme.colors.secondaryLight};
    padding-bottom: .5rem;
  }
  h3 {
    font-family: ${({theme})=>theme.fonts.heading};
    font-size: 1.5rem;
    margin-top: 2rem;
    margin-bottom: 1rem;
    color: ${({theme})=>theme.colors.dark};
  }
  p {margin: 0 0 1.5rem;}
  ul,ol {margin:0 0 1.5rem 1.5rem;}
  blockquote {
    border-left:4px solid ${({theme})=>theme.colors.primary};
    background:${({theme})=>theme.colors.lightGray};
    padding:1rem 1.25rem;
    margin:2rem 0;
    font-style:italic;
    color:${({theme})=>theme.colors.gray};
  }
  img {max-width:100%;
  border-radius:8px;
  box-shadow:0 4px 18px rgba(0,0,0,0.1);
  margin:1.8rem 0;}
`;

function PostPage() {
  const { slug } = useParams();
  const post = useMemo(() => posts.find(p=>p.slug===slug), [slug]);

  useEffect(()=>{
    window.scrollTo({top:0,behavior:'smooth'});
  },[slug]);

  if (!post) return (
    <div className="postpage not-found">
      <h1>Artículo no encontrado</h1>
      <p>Lo sentimos, el artículo que buscas no existe o ha sido movido.</p>
      <Link to="/" className="back-link">← Volver al blog</Link>
    </div>
  );

  return (
    <>
    <Article>
      <Helmet>
        <title>{post.title} - MyPunch</title>
        <meta name="description" content={post.excerpt} />
      </Helmet>
      <header>
        <h1>{post.title}</h1>
        <HeaderImg src={post.coverImage} alt={post.title} />
        {post.keywords && (
          <Keywords>
            {post.keywords.map((k,i)=>(<Chip key={i}>{k}</Chip>))}
          </Keywords>
        )}
      </header>
      {/*boton de enclace llamado PyPunch a web punchia.online */}
      <ButtonContainer>
        <Button to="https://punchia.online">
          Ir a pagina MyPunch
        </Button>
      </ButtonContainer>


      {/* Contenido del post */}
      <div className="post-content">
        <MarkdownWrapper>
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{post.content}</ReactMarkdown>
        </MarkdownWrapper>
      </div>

      {post.videoUrl && (
        <VideoSection>
          <h2>Video relacionado</h2>
          <ReactPlayer url={post.videoUrl} controls width="100%" />
        </VideoSection>
      )}
      <ButtonContainer>
        <Button to="https://punchia.online">
          Ir a pagina MyPunch
        </Button>
      </ButtonContainer>


      <footer className="post-footer">
        <Link to="/" className="back-link">← Volver al blog</Link>
      </footer>
    </Article>

    {/* Promoción AppStore */}
    <AppPromoSection>
    <AppPromoContainer>
      <AppPromoContent>
        <AppPromoTitle>
          Tu entrenador personal en la <span>palma de tu mano</span>
        </AppPromoTitle>
        <AppPromoDescription>
          Descarga nuestra app y lleva tu entrenamiento al siguiente nivel.
          Análisis en tiempo real, seguimiento de progreso y rutinas personalizadas,
          todo en una sola aplicación.
        </AppPromoDescription>
        <AppStoreButton href="https://apps.apple.com/es/app/mypunch/id6477765141?platform=iphone" target="_blank" rel="noopener noreferrer">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
          </svg>
          Disponible en App Store
        </AppStoreButton>
      </AppPromoContent>

      <ScreenshotsContainer>
        <Screenshot src="/app_dash.png" alt="Análisis de rendimiento" />
        <Screenshot src="/app_final.png" alt="Rutinas personalizadas" />
      </ScreenshotsContainer>
    </AppPromoContainer>
  </AppPromoSection>
   </>
  );
}

export default memo(PostPage);
